import React, { useContext, Fragment } from 'react';
import { store } from './reducer';
import { store as mainStore } from '../../../../../store';
import Skeleton from '@material-ui/lab/Skeleton';
import { formatNumber } from '../../../../../fns';
import moment from 'moment-jalaali';
import { __ } from '../../../../../utils/i18n';
import { makeStyles } from '@material-ui/core/styles';
import { localText } from '../../../../../langs/fa/data-grid';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import axios from '../../../../../api/axios';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: 400,
  },
}));

const Transactions = () => {
  const classes = useStyles();
  const columns = [
    {
      field: 'payerName',
      headerName: 'نام پرداخت کننده',
      flex: 1,
    },
    {
      field: 'amount',
      headerName: 'مبلغ پرداختی',
      width: 150,
    },
    {
      field: 'date',
      headerName: 'تاریخ پرداخت',
      width: 150,
    },
    {
      field: 'transactionType',
      headerName: 'نوع تراکنش',
      width: 150,
    },
    {
      field: 'description',
      headerName: 'شرح تراکنش',
      flex: 3,
    },
    {
      field: 'deleteBtn',
      headerName: 'حذف',
      width: 100,
      renderCell: ({ value }) => (
        <IconButton
          onClick={() => handleDeleteTransaction(value.transactionId)}
        >
          <DeleteIcon style={{ color: 'red' }} />
        </IconButton>
      ),
    },
  ];
  const {
    state: { transactions },
    refresh,
  } = useContext(store);
  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showMessage,
    showError,
  } = useContext(mainStore);

  const handleDeleteTransaction = async (transactionId) => {
    try {
      const { data } = await axios.delete(
        `/api/v1/admin/users/deleteTransaction/${transactionId}`
      );
      if (data?.ok) {
        showMessage(data.messages);
        refresh();
      }
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Fragment>
      {transactions ? (
        <div className={classes.root}>
          <DataGrid
            rows={
              transactions?.length
                ? transactions.map((t) => ({
                    id: t._id,
                    payerName: `${t.user?.firstName} ${t.user?.lastName}`,
                    amount: formatNumber(t.amount),
                    date: `${moment(t.createdAt).format('jYYYY/jMM/jDD')}`,
                    transactionType: __(t.transactionType),
                    description: t?.description || '',
                    deleteBtn: { transactionId: t._id },
                  }))
                : []
            }
            columns={columns}
            localeText={localText}
            pageSize={itemsCountPerPage}
            rowCount={transactions?.length || 0}
            disableMultipleSelection
            onCellClick={null}
            // onSelectionChange={handleSelectOrder}
          />
        </div>
      ) : (
        <Skeleton variant="text" height={56} />
      )}
    </Fragment>
  );
};

export default React.memo(Transactions);
